import { createStore } from 'satcheljs';
import CommandBarState from './schema/CommandBarState';
import NavigationButton from './schema/NavigationButton';

export default createStore<CommandBarState>('commandBarStore', {
    navigationButtonSelected: NavigationButton.Email,
    hidden: false,
})();
